import { render } from "./NavigationOrganization.vue?vue&type=template&id=6ae45b1f&scoped=true"
import script from "./NavigationOrganization.vue?vue&type=script&lang=js"
export * from "./NavigationOrganization.vue?vue&type=script&lang=js"

import "./NavigationOrganization.vue?vue&type=style&index=0&id=6ae45b1f&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\Tomi\\PhpstormProjects\\frontend-v2\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6ae45b1f"]])

export default __exports__